import React from "react";
import {
  House,
  Hammer,
  CirclePlus,
  Building2,
  ShoppingCart,
} from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import "./BottomNavigation.css";

export default function BottomNavigation({
  onPost,
  onCustomerMenu,
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const isHome = location.pathname === "/home";
const isProfession = location.pathname.startsWith("/profession");
const isVendor = location.pathname.startsWith("/vendor");
const isLoggedIn = !!localStorage.getItem("token");


  return (
    <nav className="bottom-bar">

      <button
      className={isHome ? "active" : ""}
        onClick={() => {
          if (location.pathname === "/home") {
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          } else {
  navigate("/home");
}
        }}
      >
        <House size={22} />
        <span>Home</span>
      </button>

      <button
      className={isProfession ? "active" : ""}
        onClick={() => navigate("/profession-dashboard")}
      >
        <Hammer size={22} />
        <span>Profession</span>
      </button>

      <button
  className="add-post"
  onClick={() => {
    if (!isLoggedIn) {
      navigate("/");
      return;
    }

    if (location.pathname === "/home") {
      onPost?.();
    } else {
      sessionStorage.setItem("civilink_open_post", "true");
      navigate("/home");
    }
  }}
>
  <CirclePlus size={28} />
</button>

      <button
  onClick={() => {
    if (!isLoggedIn) {
      navigate("/");
      return;
    }

    if (location.pathname === "/home") {
      onCustomerMenu?.();
    } else {
      sessionStorage.setItem("civilink_open_customer", "true");
      navigate("/home");
    }
  }}
>
  <Building2 size={22} />
  <span>Menu</span>
</button>

      <button
      className={isVendor ? "active" : ""}
        onClick={() => navigate("/vendor")}
      >
        <ShoppingCart size={22} />
        <span>Marketplace</span>
      </button>

    </nav>
  );
}